/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { GridHeaderComponent } from '../../cell-components/grid-component.interfaces';
import { GridSelection, GridSelector } from './grid-selectable.interfaces';

@Component({
  selector: 'gh-grid-select-all-header',
  template: `
    <mat-checkbox color="primary"
                  [checked]="checked"
                  [disabled]="disabled"
                  [indeterminate]="indeterminate"
                  [matTooltip]="(checked ? 'lbl_unselect_all' : 'lbl_select_all') | translate"
                  (change)="onChange($event.checked)"
                  (click)="onClick($event)"
    ></mat-checkbox>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSelectAllHeaderComponent implements OnInit, OnDestroy, GridHeaderComponent, GridSelector {
  id = '$all$';
  private selection: GridSelection;

  constructor(private changeDetectorRef: ChangeDetectorRef) {

  }

  get checked(): boolean {
    return this.selection.isDisabled() ? false : this.selection.isAllSelected();
  }

  get disabled(): boolean {
    return this.selection.isDisabled();
  }

  get indeterminate(): boolean {
    return this.selection.isDisabled() ? false : this.selection.isSelectedPartially();
  }

  ngOnInit(): void {
    this.selection.setAllSelector(this);
  }

  ngOnDestroy(): void {
    this.selection.removeAllSelector();
  }

  agInit(params: any): void {
    this.selection = params.selection;
  }

  refreshSelection(): void {
    this.changeDetectorRef.markForCheck();
  }

  onChange(checked: boolean): void {
    this.selection.toggleSelectAll(checked);
    this.changeDetectorRef.markForCheck();
  }

  onClick(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.selection.isDisabled()) {
      this.selection.clickSelectAll();
    }
  }
}
